import { render, staticRenderFns } from "./btn-tertiary.vue?vue&type=template&id=e03bf1d8&scoped=true&"
import script from "./btn-tertiary.vue?vue&type=script&lang=js&"
export * from "./btn-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03bf1d8",
  null
  
)

export default component.exports